/**
 * EventHelper
 *
 * @class EventHelper
 * @author Philip Bräunlich
 */
const placesSelected = new Set();
const listeners = new Map();

class EventHelper {

	/**
	 * @param {object} place
	 * @param {object} options
	 * @param {Boolean} options.single => place should be the only selected place
	 * @param {Boolean} options.panTo => map panTo place
	 */
	static selectPlace ({placeId, options}) {
		if (options.single) {
			placesSelected.clear();
		}
		
		placesSelected.add(placeId);
		
		self.dispatchEvent(new CustomEvent('placeSelected', {
			detail: {
				places: [...placesSelected],
				options
			}
		}));
	}
	
	static unselectPlace (placeId) {
		if (placeId) {
			placesSelected.delete(placeId);
		} else {
			placesSelected.clear();
		}
		
		self.dispatchEvent(new CustomEvent('placeSelected', {
			detail: {
				places: [...placesSelected],
				options: {}
			}
		}));
	}
	
	static isPlaceSelected (placeId) {
		return placesSelected.has(placeId);
	}
	
	static onPlaceSelect (view, cb) {
		const listener = (e) => { cb.call(view, e.detail); };
		if (!listeners.has(view)) {
			listeners.set(view, []);
		}
		const removers = listeners.get(view);
		removers.push(() => self.removeEventListener('placeSelected', listener));
		
		self.addEventListener('placeSelected', listener);
	}
	
	static removeListeners (view) {
		if (!listeners.has(view)) {
			return;
		}
		
		const removers = listeners.get(view);
		for (const remover of removers) {
			remover();
		}
		listeners.delete(view);
	}
	
	static selectCity (city) {
		self.dispatchEvent(new CustomEvent('citySelected', {detail: city}));
	}
	
	static onCitySelect (cb) {
		self.addEventListener('citySelected', (e) => {
			cb(e.detail);
		});
	}
	
	static geometry (geometry) {
		self.dispatchEvent(new CustomEvent('geometry', {
			detail: {
				geometry
			}
		}));
	}
	
	static onGeochange (cb) {
		self.addEventListener('geometry', (e) => {
			cb(e.detail);
		});
	}
}

module.exports = EventHelper;
